"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttrService = void 0;
class AttrService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data(el, attr) {
        if (!el || !(el instanceof HTMLElement))
            return;
        const data = el === null || el === void 0 ? void 0 : el.dataset[attr
            .split('-')
            .reduce((prev, current) => `${prev}${current.charAt(0).toUpperCase()}${current.slice(1)}`)];
        el === null || el === void 0 ? void 0 : el.removeAttribute(`data-${attr}`);
        try {
            return JSON.parse(data);
        }
        catch (e) {
            return data;
        }
    }
    attr(el, attr) {
        const data = el.getAttribute(attr);
        el.removeAttribute(attr);
        return data;
    }
}
const service = new AttrService();
exports.AttrService = service;
